export type TUserProfile = {
  id?: string
  memberInfoId: string
  clientSn: number
  refCode: string
  nickName?: string
  roles: number[]
  roleDetail: {
    [key: string]: {
      tags: string[]
      idType: string
      id: string
    }
  }
  headshotUrl: string
  intro: string
  countryCode: string
  phone: string
  email: string
  birthday: string
  gender: any
  profileName: string
  isTagSetup?: boolean
  isPinned: boolean
  isFollowing: boolean
  allowFollow: boolean
  currentRoleType: USER_ROLE
  merchantId?: string
}

export enum USER_ROLE {
  DEFAULT = 0,
  ADMIN = 1,
  MERCHANT = 2,
  KOL = 4,
  RD = 8,
}
